import React from 'react'
import style from './Loading.less'
import ticketStyle from '../Ticket/Ticket.less'
import GreyBlock from 'common/components/chips/GreyBlock'
import MediaQuery from 'react-responsive'
import PropTypes from 'prop-types'
import { loadingMsg } from './Loading.messages'

const MEDIA_QUERY_TABLET = 720

const createTicketList = (num) => (
  Array(num).fill().map((item, index) => (
    <div className={ticketStyle.containerWrapper} key={index}>
      <div className={ticketStyle.containerInnerWrapper}>
        <div className={ticketStyle.ticketWrapper}>
          <section className={ticketStyle.details}>
            <div className={ticketStyle.header}>
              <MediaQuery minWidth={MEDIA_QUERY_TABLET}>
                <div className={ticketStyle.operatorLogo}>
                  <GreyBlock height="30" block />
                </div>
              </MediaQuery>
              <div className={ticketStyle.timeLocationInfo}>
                <div className={ticketStyle.date}>
                  <GreyBlock width="80" height="26" right />
                  <GreyBlock width="80" height="26" right />
                </div>
                <div className={ticketStyle.routeInfo}>
                  <GreyBlock width="120" height="18" right />
                  <GreyBlock width="120" height="18" right />
                </div>
              </div>
              <div className={ticketStyle.duration}>
                <GreyBlock width="140" height="20" block />
              </div>
            </div>
          </section>
          <MediaQuery minWidth={MEDIA_QUERY_TABLET}>
            <section className={ticketStyle.more}>
              <GreyBlock height="26" block top />
              <GreyBlock height="10" block top />
              <GreyBlock height="38" block top />
            </section>
          </MediaQuery>
        </div>
      </div>
    </div>
  ))
)

const Loading = (props) => (
  <div className={style.main}>
    <h2 className={style.loadingHeader}>{loadingMsg}</h2>
    <div className={style.filters}>
      <GreyBlock height="32" width="120" right />
      <GreyBlock height="32" width="120" right />
      <GreyBlock height="32" width="120" />
    </div>
    {createTicketList(props.tickets)}
  </div>
)

Loading.defaultProps = {
  tickets: 5,
}

Loading.propTypes = {
  tickets: PropTypes.number,
}

export default Loading
